$(() => {
  annual_field_service_spend = () => {
    return parseInt($('#annual-field-service-spend').val().replaceAll(',', ''));
  }

  annual_subscription_rate = () => {
    return parseFloat($('#annual-subscription-rate').val()) / 100;
  }

  targeted_spend_with_fn = () => {
    return parseInt($('#targeted-spend-with-fn').val().replaceAll(',', ''));
  }

  pct_field_work_outsourced = () => {
    return parseInt($('#pct-field-work-outsourced').val());
  }

  targeted_spend_with_fn = () => {
    return parseFloat($('#targeted-spend-with-fn').val().replaceAll(',', ''));
  }

  annual_subscription_fee = () => {
    return accounting.formatMoney(targeted_spend_with_fn() * annual_subscription_rate(), '', 2);
  }

  pct_service_spend_on_field_nation = () => {
    return Math.round((targeted_spend_with_fn() / (annual_field_service_spend() * (pct_field_work_outsourced() / 100)) * 100));
  }

  const run = () => {
    $('#pct-service-spend-on-field-nation').val(pct_service_spend_on_field_nation());
    $('#annual-subscription-fee').val(annual_subscription_fee());
  };

  $('#targeted-spend-with-fn, #annual-field-service-spend, #pct-field-work-outsourced, #annual-subscription-rate').change(() => {
    run();
  });
});
